import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Camera, DollarSign } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <MapPin className="w-8 h-8 text-slate-900" data-id="element-96" />,
    title: 'PASO 1: Ubica el tesoro',
    desc: 'Usa nuestra guía de proveedores locales de liquidación.'
  }, {
    icon: <Camera className="w-8 h-8 text-slate-900" data-id="element-97" />,
    title: 'PASO 2: Publica como experta',
    desc: 'Usa el sistema de fotos y títulos que Facebook ama.'
  }, {
    icon: <DollarSign className="w-8 h-8 text-slate-900" data-id="element-98" />,
    title: 'PASO 3: Cobra y repite',
    desc: 'Entrega el producto, recibe tu efectivo y repite el proceso.'
  }];
  return <section className="w-full bg-slate-900 py-16 md:py-24" data-id="element-99">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-102">
            Cómo funciona el sistema
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-103">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-1 bg-slate-700 -z-10" data-id="element-104"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center" data-id="element-105">
              <div className="w-24 h-24 bg-gold-gradient rounded-full flex items-center justify-center shadow-lg mb-6 transform transition-transform hover:scale-110" data-id="element-106">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-107">
                {step.title}
              </h3>
              <p className="text-slate-400 max-w-xs" data-id="element-108">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}